import { render } from "./ListeMpostBox.vue?vue&type=template&id=0d0c1329&ts=true"
import script from "./ListeMpostBox.vue?vue&type=script&lang=ts"
export * from "./ListeMpostBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__